"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeMatrixKey = sanitizeMatrixKey;
exports.canonicalRoleKeyForMatrix = canonicalRoleKeyForMatrix;
const MemberTypes_1 = require("../MemberTypes");
function sanitizeMatrixKey(value) {
    if (!value) {
        return "";
    }
    return String(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "_")
        .toLowerCase();
}
function canonicalRoleKeyForMatrix(normalizedRole) {
    if (!normalizedRole) {
        return normalizedRole;
    }
    if (normalizedRole === "collaborateur") {
        return "collaborator";
    }
    if (normalizedRole === "notaire") {
        return "notary";
    }
    if (normalizedRole === "invite") {
        return "guest_notary";
    }
    if ((0, MemberTypes_1.isThirdParty)(normalizedRole)) {
        return MemberTypes_1.USER_TYPE_THIRDPARTY;
    }
    return normalizedRole;
}
